import { render, staticRenderFns } from "./IntroductionCollage.vue?vue&type=template&id=12cc0905&"
import script from "./IntroductionCollage.vue?vue&type=script&lang=js&"
export * from "./IntroductionCollage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports